import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect(){
    document.onkeydown = (event) => {
      event = event || window.event
      var isEscape = false
      if ("key" in event) {
        isEscape = (event.key === "Escape" || event.key === "Esc")
      } else {
        isEscape = (event.keyCode === 27)
      }
      if (isEscape && document.body.classList.contains('modal-active')) {
        this.hide()
      }
    };

    document
      .querySelectorAll(`.modal.in`)
      .forEach((target) => {
        target.querySelector('.modal-close').addEventListener('click', this.hide)
        target.querySelector('.modal-overlay').addEventListener('click', this.hide)
      })
  }

  show(event){
    event.preventDefault()
    var target = event.currentTarget.dataset.modalTarget;
    document
        .querySelectorAll(`[data-modal-name="${target}"]`)
        .forEach((target) => {
          target.classList.add('in')
          target.querySelector('.modal-close').addEventListener('click', this.hide)
          target.querySelector('.modal-overlay').addEventListener('click', this.hide)
        })
    document.querySelector('body').classList.add('modal-active');


    if (typeof ga === "function") {
      ga('send', 'event', 'Modal', 'open', target);
    }
  }

  hide(){
    document.querySelectorAll('.modal.in').forEach((target) => {
      target.classList.remove('in')
    })
    document.querySelector('body').classList.remove('modal-active')
  }
}
